import React from "react";
import { ClipboardList } from "lucide-react";
import DocumentApprovalCard from "./DocumentApprovalCard";
import CompanyFormsInfoBanner from "./CompanyFormsInfoBanner";

const bulkBtn =
  "company-forms-btn inline-flex items-center justify-center rounded-lg px-2.5 py-1.5 text-[11px] font-semibold transition disabled:cursor-not-allowed disabled:opacity-50";

export default function CompanyFormsApproveInbox({
  items,
  busyId,
  categoryLabels,
  onApprove,
  onReject,
  selectedIds,
  onToggleSelect,
  onSelectAll,
  onClearSelection,
  onBulkApprove,
  onBulkReject,
  bulkBusy,
}) {
  const selectedCount = selectedIds?.size ?? 0;
  const allSelected = items.length > 0 && selectedCount === items.length;

  if (!items.length) {
    return (
      <div className="rounded-xl border border-[#E5ECF5] bg-white px-5 py-10 text-center shadow-[0_1px_2px_rgba(20,33,61,0.05)]">
        <p className="m-0 text-sm font-semibold text-[#14213D]">You&apos;re all caught up</p>
        <p className="mx-auto mt-1.5 max-w-sm text-xs leading-relaxed text-[#64748B]">
          Nothing is waiting for approval.
        </p>
      </div>
    );
  }

  return (
    <section aria-label="Documents waiting for approval">
      <CompanyFormsInfoBanner bannerKey="approve-info" icon={ClipboardList}>
        <span className="font-medium text-[#14213D]">
          <span className="font-semibold text-[#007BFF]">{items.length}</span>{" "}
          {items.length === 1 ? "document pending" : "documents pending"}
        </span>
        <span className="text-[#64748B]">
          {" "}
          Select items for bulk approve, or use actions on each card.
        </span>
      </CompanyFormsInfoBanner>

      <div className="mb-3 flex flex-wrap items-center gap-2 rounded-lg border border-[#E5ECF5] bg-white px-3 py-2 shadow-[0_1px_2px_rgba(20,33,61,0.05)]">
        <label className="inline-flex cursor-pointer items-center gap-2 text-[11px] font-medium text-[#475569]">
          <input
            type="checkbox"
            className="h-3.5 w-3.5 shrink-0 cursor-pointer accent-[#007BFF]"
            checked={allSelected}
            disabled={bulkBusy}
            onChange={(e) => onSelectAll?.(e.target.checked)}
          />
          Select all on page
        </label>

        {selectedCount > 0 ? (
          <>
            <span className="text-[11px] font-semibold text-[#64748B]">
              · {selectedCount} selected
            </span>
            <div className="flex flex-wrap items-center gap-1.5 sm:ml-auto">
              <button
                type="button"
                disabled={bulkBusy}
                onClick={onBulkApprove}
                className={`${bulkBtn} border-0 bg-[#007BFF] text-white hover:bg-[#0069d9]`}
              >
                Approve selected
              </button>
              <button
                type="button"
                disabled={bulkBusy}
                onClick={onBulkReject}
                className={`${bulkBtn} border border-[#FECACA] bg-white text-[#EF4444] hover:bg-[#FEF2F2]`}
              >
                Reject selected
              </button>
              <button
                type="button"
                disabled={bulkBusy}
                onClick={onClearSelection}
                className={`${bulkBtn} border border-[#E5ECF5] bg-[#F8FAFC] text-[#64748B] hover:bg-[#EFF6FF]`}
              >
                Clear
              </button>
            </div>
          </>
        ) : null}
      </div>

      <ul className="company-forms-approve-inbox-grid">
        {items.map((item) => (
          <DocumentApprovalCard
            key={item.id}
            item={item}
            busy={busyId === item.id || bulkBusy}
            categoryLabels={categoryLabels}
            onApprove={onApprove}
            onReject={onReject}
            selectionEnabled
            selected={selectedIds?.has(item.id)}
            onToggleSelect={onToggleSelect}
          />
        ))}
      </ul>
    </section>
  );
}
